
import React from "react";
import { CheckCircle2 } from "lucide-react";

export function CompletionStep() {
  return (
    <div className="space-y-4 text-center">
      <div className="flex justify-center mb-6">
        <div className="w-16 h-16 rounded-full bg-primary/10 flex items-center justify-center">
          <CheckCircle2 className="h-8 w-8 text-primary" />
        </div>
      </div>
      
      <h2 className="text-xl font-semibold">Setup Complete!</h2>
      
      <p className="text-muted-foreground">
        Congratulations! You've successfully configured your ContractFlow account.
        You're now ready to start managing your contracts efficiently.
      </p>
      
      <div className="bg-muted p-4 rounded-lg mt-6 text-left">
        <h3 className="font-medium mb-2">What's Next?</h3>
        <ul className="space-y-2 ml-6 list-disc">
          <li>Add your first contract</li>
          <li>Invite team members to collaborate</li>
          <li>Set up notifications for contract renewals</li>
          <li>Explore the reporting and analytics features</li>
        </ul>
      </div>
      
      <p className="mt-6">
        You can access this setup guide again anytime from the Settings page.
      </p>
    </div>
  );
}
